export function on (obj, ...args) {
  obj.addEventListener(...args)
}

export function off (obj, ...args) {
  obj.removeEventListener(...args)
}

export function cn (...args) {
  return args.filter(Boolean).join(' ')
}
